export default __webpack_public_path__ + "static/media/done-green.f8d36e16.svg";